export const API_BASE = import.meta.env.VITE_API_URL || 'http://localhost:4000'

export function storedToken() { return localStorage.getItem('coeater_token') }
export function saveToken(t)   { localStorage.setItem('coeater_token', t) }
export function clearToken()   { localStorage.removeItem('coeater_token') }

export function decodeJwt(token) {
  try { return JSON.parse(atob(token.split('.')[1])) } catch { return null }
}

export async function apiFetch(path, opts = {}) {
  const token = storedToken()
  return fetch(`${API_BASE}${path}`, {
    ...opts,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(opts.headers || {})
    }
  })
}

// For multipart/form-data uploads — do NOT set Content-Type (browser sets boundary automatically)
export async function apiUpload(path, formData) {
  const token = storedToken()
  return fetch(`${API_BASE}${path}`, {
    method: 'POST',
    body: formData,
    headers: token ? { Authorization: `Bearer ${token}` } : {}
  })
}
